import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../../components/Component";
import MySelect from "../../../MyComp/UI/form/MySelect";

import DeleteModal from "../../../MyComp/UI/modals/DeleteModal";
import ConfirmModal from "../../../MyComp/UI/modals/ConfirmModal";
import MyButton from "../../../MyComp/UI/form/MyButton";
import useLogout from "../../../hooks/useLogout";
import ViewImgAndPdf from "../../ImageFolder/ViewImageAndPdf";
import MyDataTable from "../../../MyComp/UI/DataTable/MyDataTable";
import Status from "../../../MyComp/UI/form/Status";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { categoryPackageAPI, categoryPackageDDAPI, categoryTestDDAPI, getSubgorupDD, packageDD, subCategoryDDAPI, testDDAPI, testListAPI, testListDDAPI } from "../../../api/dropdown";
import {
  craeteLabBoy,
  createLabPackageAPI,
  createPackageAPI,
  createPackageTestAPI,
  deletePackageTest,
  getLabBoyList,
  getListPAckageTestAPI,
  listLabPackageAPI,
  listPackageAPI,
  updateGroupAPI,
  updateLabBoy,
  updateLabPackageAPI,
  updatePackageAPI,
  updatePackageTestAPI,
  uploadTestCatalog,
  uploadTestPackageCatalog,
} from "../../../api/master/indes";
import { BASE_EXCEL_URL, BASE_URL_IMG } from "../../../assets/constants";
import MyInput from "../../../MyComp/UI/form/MyInput";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import ApiPaginationDataTable from "../../../MyComp/UI/DataTable/ApiPaginationDataTable";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import { useLocation } from "react-router-dom";


const LabBoy = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");

  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [perPage, setPerPage] = useState(25);
  const [itemPerPage, setItemPerPage] = useState(25);


  const [debouncedSearch, setDebouncedSearch] = useState("");
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
    console.log("rows", page, rows);
  };
  const handlePageChange = (page) => {
    console.log("page", page);
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };
  // Table Columns
  const [column, setColumn] = useState([
    // {
    //   name: "Image",
    //   selector: (row) => (
    //     <div  >
    //       {/* <img
    //         style={{ width: "50px", height: "50px", borderRadius: "6px" }}
    //         src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
    //       /> */}
    //        <UserAvatarCell row={row} name={row?.name} handleImageOpenPreview={handleImageOpenPreview} image={`${BASE_URL_IMG}${row.image}`}/>

    //     </div>
    //   ),
    //   sortable: false,
    //   wrap: true,
    // },
    {
      name: "  Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Mobile ",
      selector: (row) => row?.mobile || "-",
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "Group  ",
    //   selector: (row) => row?.group || "-",
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: "Email  ",
      selector: (row) => row?.email || "-",
      sortable: true,
      wrap: true,
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>{" "}
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);

  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };
  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);
  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
      labId: labId,
    };
    setLoading(true);
    getPackageList(body)
      .then((res) => {
        const status = res.data.status;
        console.log(res, "resss");
        if (status === true) {
          setLoading(false);
          console.log("limit", res?.data?.data?.totalRecords);
          console.log("server side res", res?.data?.data?.result);
          setTotalRows(res?.data?.data?.totalRecords);
          setValue("limit", res?.data?.data?.totalRecords);
          setTableData(res?.data?.data?.labBoyList);
        } else if (status === false) {
          setLoading(false);
          setTableData([]);
        } else if (status === "expired") {
          setLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("catch error", err);
      });
  };
  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    // setLoading(true);
    setValue("isLoading", true);

    deletePackageTest({ id: watch("selectedRow").id })
      .then((res) => {
        setValue("isLoading", false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  // Fetch group list
  useEffect(() => {
    const body = {
      search: debouncedSearch,
      page: currentPage,
      limit: itemPerPage,

      labId: labId
    };
    getPackageList(body);
  }, []);
  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };
  useEffect(() => {
    const body = {
      // search: debouncedSearch,
      page: currentPage,

      limit: itemPerPage,

      labId: labId,
    };
    getPackageList(body);
  }, []);
  const getPackageList = async (body) => {
    try {
      setValue("isLoading", true);

      const res = await getLabBoyList(body);

      if (res?.data?.status === true) {
        console.log(res?.data?.data, " res?.data?.data");
        const list = res?.data?.data?.tests || [];
        const total = res?.data?.data?.total || 0;
        setTableData(res?.data?.data?.labBoyList);
        setTotalRows(res?.data?.data?.totalRecords);
        setValue("limit", res?.data?.data?.totalRecords);
        setValue("data", list);
        // setTotalRows(total); // 👈 set total count
      } else if (res?.data?.status === "expired") {
        setTableData([]);
        logout();
      } else {
        setValue("data", []);
        setTotalRows(0);
        toast.error(res?.data?.message);
      }
    } catch (err) {
      setValue("data", []);
      setTotalRows(0);
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
    }
  };
  // const getPackageList = async (body) => {
  //   try {
  //     const res = await getListPAckageTestAPI(body);
  //     if (res.data.status === "expired") {
  //       toast.error(res.data.message);
  //       toast.clearWaitingQueue();
  //     } else if (res.data.status === true) {
  //       setValue("data", res.data.data.packageList);
  //       console.log(res.data,"daaaa")
  //     } else {
  //       setValue("data", []);
  //       toast.error(res.data.message);
  //     }
  //   } catch (err) {
  //     toast.error(err?.response?.data?.message);
  //   } finally {
  //     setValue("isLoading", false);
  //   }
  // };
  const onFormSubmit = async (formData) => {
    try {
      setValue("isLoading", true);

      const payload = {
        name: formData.name,
        mobile: formData.mobile_number,
        email: formData.email,
        //   package: formData?.package?.label || "",
        //   category: formData?.category?.label || "",
        //   subcategory: formData?.subcategory?.label || "",
        //   test: Array.isArray(formData?.test)
        //     ? formData.test.map((item) => item.label)
        //     : [],
        status: formData?.status?.value ?? true,
        labId: labId,
      };

      if (mode === "Edit" && formData?.selectedRow?.id) {
        payload.id = formData.selectedRow.id;
      }

      console.log("FINAL PAYLOAD:", payload);

      const res =
        mode === "Add"
          ? await craeteLabBoy(payload)
          : await updateLabBoy(payload);

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        getPackageList({
          search: debouncedSearch,
          page: currentPage,
          limit: itemPerPage,
          labId: labId,
        });
        resetF();
        setMode("Add");
        setIsOpen(false);
      } else if (res?.data?.status === "expired") {
        logout();
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setValue("isLoading", false);
    }
  };


  const handleEdit = async (row) => {
    window.scrollTo(0, 0);

    setIsEditing(true);
    setMode("Edit");
    setIsOpen(true);
    setValue("selectedRow", row);
    setValue("name", row.name);
    setValue("mobile_number", row.mobile);
    setValue("email", row.email);


    // Package
    //   setValue("package", {
    //     label: row.package,
    //     value: row.package_id,
    //   });

    //   // Category
    //   setValue("category", {
    //     label: row.group,
    //     value: row.categoryId,
    //   });

    //   // Wait for subcategory list
    //   await getSubCategory(row.group);

    //   setValue("subcategory", {
    //     label: row.subgroup,
    //     value: row.subcategoryId,
    //   });

    // Wait for test list
    //   await getTest(row.group, row.subgroup);

    // Multi test set properly
    //   setValue(
    //     "test",
    //     row.test
    //       ? row.test.split(",").map((t) => ({
    //           label: t.trim(),
    //           value: t.trim(),
    //         }))
    //       : []
    //   );

    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });

    // Stop editing flag after small delay
    setTimeout(() => setIsEditing(false), 500);
  };


  useEffect(() => {
    getPackage();
  }, [mode]);
  const getPackage = () => {
    categoryPackageAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("packageDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("packageDD", []);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
      // id: watch("selectedRow").id,
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getGroupList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const resetF = () => {
    setValue("name", null);
    setValue("mobile_number", null);
    setValue("email", null);

    setValue("status", null);


    clearErrors()
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };


  // useEffect(() => {
  //   if (!isEditing) {
  //     setValue("test", null);
  //   }
  // }, [watch("category"), watch("subcategory")]);




  const {
    clearErrors: clearErrorsTest,
    register: registerTest,
    handleSubmit: handleSubmitTest,
    control: controlTest,
    setValue: setValueTest,
    watch: watchTest,
    trigger: triggerTest,
    formState: { errors: errorsTest },
    reset: resetTest,
    setError: setErrorTest,
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
    mode: "onChange",
  });
  const handleUploadClick = () => {
    setDownloadModalOpen(true);
  };
  const labId = localStorage.getItem("userId");
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  // New: Handle Upload click to show download modal
  const uploadTestCatalogAPI = async () => {
    try {
      setUploading(true);
      const file = watchTest("file");
      if (!file) {
        toast.errorsTest("Please select an Excel file");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("labId", labId);

      const res = await uploadTestPackageCatalog(formData);

      if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
        logout();
      } else if (res?.data?.status === true) {
        toast.success(res.data.message || "Excel uploaded successfully");
        handleCancel();
        setDownloadModalOpen(false);
        getPackageList({
          search: debouncedSearch,
          page: currentPage,
          limit: itemPerPage,
          labId: labId,
        });
        setValueTest("data", res.data.data || []);
      } else {
        toast.error(res?.data?.message || "Upload failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      setValueTest("file", null);
      setErrorTest("file", { type: "manual", message: "File is required" });
      return;
    }

    validateExcel(selectedFile, (isValid) => {
      if (isValid) {
        clearErrorsTest("file");
        setValueTest("file", selectedFile);
      } else {
        setValueTest("file", null);
        setErrorTest("file", { type: "manual", message: "Invalid file type. Please upload a valid Excel file." });
        toast.error("Invalid file type. Please upload a valid Excel file.");
        e.target.value = null;
      }
    });
  };
  useEffect(() => {
    if (!downloadModalOpen) {
      setValue("file", null);
      clearErrors("file");

      // reset actual file input DOM value
      const input = document.getElementById("fileInput");
      if (input) {
        input.value = "";
      }
    }
  }, [downloadModalOpen]);
  const handleCancel = () => {
    setValueTest("file", null);
    clearErrorsTest("file");

    const input = document.getElementById("fileInput");
    if (input) {
      input.value = "";
    }
  };


  const validateExcel = (file, callback) => {
    const reader = new FileReader();

    const fileName = file.name.toLowerCase();
    const isXlsExtension = fileName.endsWith(".xls");
    const isXlsxExtension = fileName.endsWith(".xlsx");

    if (!isXlsExtension && !isXlsxExtension) {
      callback(false);
      return;
    }

    reader.onloadend = function (event) {
      const arr = new Uint8Array(event.target.result).subarray(0, 4);
      let header = "";
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16).padStart(2, "0");
      }
      header = header.toUpperCase();

      const isXls = header === "D0CF11E0"; // XLS
      const isXlsx = header === "504B0304"; // XLSX
      const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);

      callback(isExcel);
    };

    reader.onerror = function () {
      callback(false);
    };

    reader.readAsArrayBuffer(file.slice(0, 4));
  };
  const [uploading, setUploading] = useState(false);
  useEffect(() => {

    // getCategory();
  }, [mode]);

  useEffect(() => {
    getPackageDD();
  }, [mode]);
  const getPackageDD = () => {
    packageDD()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("packageDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("packageDD", []);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (isEditing) return;
    const categoryId = watch("package")?.value;
    const subCategoryId = watch("subcategory")?.value;

    if (categoryId) {
      getSubCategory(categoryId);
    } else {
      setValue("subCategoryDD", []);
    }

    if (categoryId && subCategoryId) {
      // getTest(categoryId, subCategoryId);
    } else {
      // setValue("testDD", []);
    }
  }, [watch("category"), watch("subcategory")]);

  useEffect(() => {
    if (!isEditing) {
      setValue("subcategory", null);
    }
  }, [watch("category")]);

  useEffect(() => {
    getCategory();
  }, [mode]);

  useEffect(() => {
    if (!isEditing) return;
    const categories = watch("category"); // array of selected categories

    if (Array.isArray(categories) && categories.length > 0) {
      // Extract all selected IDs
      const categoryIds = categories.map((cat) => cat.value);
      getSubCategory(categoryIds);
    } else {
      setValue("subCategoryDD", []);
    }
  }, [watch("category")]);
  useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (isEditing) return;

    const categoryId = watch("package")?.value;
    const subCategoryId = watch("subcategory")?.value;

    if (categoryId) {
      getSubCategory(categoryId);
    } else {
      setValue("subCategoryDD", []);
    }

    if (categoryId && subCategoryId) {
      // getTest(categoryId, subCategoryId);
    } else {
      setValue("testDD", []);
    }

  }, [watch("category"), watch("subcategory")]);

  // useEffect(() => {
  //   const categoryId = watch("category")?.value;
  //   const subCategoryId = watch("subcategory")?.value;

  //   if (categoryId) {
  //     getSubCategory(categoryId);
  //   } else {
  //     setValue("subCategoryDD", []);
  //   }

  //   if (categoryId && subCategoryId) {
  //     getTest(categoryId, subCategoryId);
  //   } else {
  //     setValue("testDD", []);
  //   }
  // }, [watch("category"), watch("subcategory")]);

  useEffect(() => {
    if (!isEditing) {
      setValue("subcategory", null);
    }
  }, [watch("category")]);

  // useEffect(() => {
  //   setValue("subcategory", null);
  // }, [watch("category")]);
  // useEffect(()=>{
  //   getTest();
  // },[mode])

  // const getTest = (categoryId, subCategoryId) => {
  //   const body = {
  //     categoryId,
  //     subCategoryId,
  //   };

  //   testListAPI(body)
  //     .then((res) => {
  //       if (res.data.status === true) {
  //         setValue("testDD", res.data.data);
  //       } else if (res.data.status === "expired") {
  //         toast.error(res.data.message);
  //         logout();
  //       } else {
  //         setValue("testDD", []);
  //         toast.error(res.data.message);
  //       }
  //     })
  //     .catch((err) => {
  //       toast.error(err?.response?.data?.message);
  //     })
  //     .finally(() => {
  //       setValue("isLoading", false);
  //     });
  // };
  const getTest = (name) => {
    const body = {
      name
    };

    testListDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("testDD", res.data.data);
        } else if (res.data.status === "expired") {
          // toast.error(res.data.message);
          logout();
        } else {
          setValue("testDD", []);
          // toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };
  const getSubCategory = (package_id) => {
    const body = { package_id };

    getSubgorupDD(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          // toast.error(res.data.message);
          logout();
        } else {
          setValue("subCategoryDD", []);
          // toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // toast.error(err?.response?.data?.message);
      });
  };
  const selectedPackage = watch("package");
  const selectedSubGroup = watch("subcategory");

  useEffect(() => {
    getPackageDD();
  }, []);

  useEffect(() => {
    if (!selectedPackage?.value) {
      setValue("subCategoryDD", []);
      setValue("subcategory", null);
      return;
    }

    getSubCategory(selectedPackage.value);

  }, [selectedPackage]);

  useEffect(() => {
    if (!selectedSubGroup?.label) {
      setValue("testDD", []);
      return;
    }

    getTest(selectedSubGroup.label);

  }, [selectedSubGroup]);

  // const getSubCategory = (categoryId) => {
  //   const body = { categoryId };

  //   subCategoryDDAPI(body)
  //     .then((res) => {
  //       if (res.data.status === true) {
  //         setValue("subCategoryDD", res.data.data);
  //       } else if (res.data.status === "expired") {
  //         // toast.error(res.data.message);
  //         logout();
  //       } else {
  //         setValue("subCategoryDD", []);
  //         toast.error(res.data.message);
  //       }
  //     })
  //     .catch((err) => {
  //       toast.error(err?.response?.data?.message);
  //     });
  // };
  const location = useLocation();
  const isLabTechPage = location.pathname.includes("laboratory-technician");

  const isEmailRequired = !isLabTechPage;
  return (
    <>
      <Head title=" Laboratory Technician | Laboratory Technician" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Laboratory Technician
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <>
                {/* <Button color="primary" outline style={{ marginRight: "15px" }} onClick={handleUploadClick}>
                  <Icon name="upload" />
                </Button> */}
                <Button
                  color="primary"
                  outline
                  className="me-n1"
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  {/* <Col md="4" className={``}>
                      <MySelect
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"Pacakge"}
                        name={"package"}
                      readonly
                        placeholder={"Select Package"}
                        required
                        options={watch("packageDD")}
                        // multi
                      />
                    </Col> */}
                  {/* <Col md="4" className={``}>
                      <MySelect
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"Group"}
                        name={"category"}
                        placeholder={"Select Group"}
                        required
                        options={watch("categoryDD")}
                        // multi
                      />
                    </Col> */}
                  {/* <Col md="4" className={``}>
                      <MySelect
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"Sub Group"}
                        name={"subcategory"}
                        placeholder={"Select Sub Group"}
                        required
                        options={watch("subCategoryDD")}
                        // multi
                      />
                    </Col>
                    <Col md="4" className={``}>
                      <MySelect
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"Test"}
                        name={"test"}
                        placeholder={"Select test"}
                        required
                        options={watch("testDD")}
                        multi
                      />
                    </Col> */}
                  {/* <Col md="4">
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title="Package Name"
                        name="package_name"
                        placeholder="Enter package name"
                        required
                        min={2}
                        max={50}
                        disabled={watch("addSub")}
                      />
                    </Col> */}
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title=" Name"
                      name="name"
                      placeholder="Enter  Name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>
                  {/* <Col md="4">
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title="Mobile Number"
                        name="mobile_number"
                        placeholder="Enter Mobile Number"
                        required
                        min={2}
                        max={10}
                        disabled={watch("addSub")}
                      />
                    </Col> */}
                  <Col xs="12" sm="6" md="4" lg="3">
                    <MyMobile
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Mobile Number"
                      name="mobile_number"
                      placeholder="Enter Mobile Number"
                      required
                      disabled={watch("addSub")}
                    />
                  </Col>
                  <Col md="4" className={``}>
                    <MyEmail
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Email"}
                      name={"email"}
                      placeholder={"Enter email"}
                      required={isEmailRequired}
                      disabled={mode == "Approval"}
                    />
                  </Col>
                  {/* <Col md="4">
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title="Test Name"
                        name="test_name"
                        placeholder="Enter test name"
                        required
                        min={2}
                        max={50}
                        disabled={watch("addSub")}
                      />
                    </Col> */}
                  {/* <Col md="3">
                      <ImageUpload
                        name="package_image"
                        id="package_image"
                        watch={watch}
                        label="Upload Package Image"
                        errors={errors}
                        register={register}
                        trigger={trigger}
                        clearErrors={clearErrors}
                        image="package_img"
                        setError={setError}
                        image_url="package_image"
                        setValue={setValue}
                        handleImageOpenPreview={handleImageOpenPreview}
                        required
                        getValues={getValues}
                      />
                    </Col> */}

                  <Col md="4">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      required
                    />
                  </Col>
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}
          <ApiPaginationDataTable
            columns={column}
            data={tableData}
            title={"Laboratory Technician List"}
            isLoading={loading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
          />
          {/* <MyDataTable data={data || []} columns={column} title="Package Test List" isLoading={isLoading} /> */}
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={watch("isLoading")}
      />
      <Modal isOpen={downloadModalOpen} toggle={() => setDownloadModalOpen(false)} centered>
        <ModalHeader toggle={() => setDownloadModalOpen(false)}>Upload Test Catalog (Excel)</ModalHeader>

        <ModalBody>
          <div className="d-block justify-content-between">
            <div
              style={{
                // maxWidth:'250px',
                border: "2px dashed #cfd4da",
                borderRadius: "10px",
                padding: "5px",
                textAlign: "center",
                background: "#f8f9fa",
              }}
            >
              {watchTest("file") ? (
                <div
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "10px",
                    padding: "20px",
                    background: "#ffffff",
                  }}
                >
                  <Icon name="file-excel" style={{ fontSize: "28px", color: "green" }} />
                  <p
                    style={{
                      marginTop: "10px",
                      wordBreak: "break-word",
                      fontWeight: "600",
                    }}
                  >
                    {watchTest("file")?.name}
                  </p>

                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <Button color="danger" size="sm" className="p-2" outline onClick={handleCancel}>
                      Remove
                    </Button>
                    <Button
                      className="p-2"
                      color="primary"
                      size="sm"
                      disabled={uploading}
                      onClick={uploadTestCatalogAPI}
                    >
                      {/* {uploading ? "Uploading..." : "Upload"} */}
                      {"Upload"}
                    </Button>
                  </div>
                </div>
              ) : (
                /* FILE INPUT */
                <>
                  <label
                    htmlFor="fileInput"
                    style={{
                      cursor: "pointer",
                      display: "block",
                    }}
                  >
                    <Icon name="upload" style={{ fontSize: "30px", color: "#0d6efd" }} />
                    <p style={{ marginTop: "5px", fontWeight: "500" }}>Click to upload test catalog</p>
                    {/* <small style={{ color: "#6c757d" }}>
              Supported formats: .xls, .xlsx
            </small> */}
                  </label>

                  <input
                    type="file"
                    id="fileInput"
                    accept=".xls,.xlsx"
                    style={{ display: "none" }}
                    {...registerTest("file", { requiredTest: "File is required" })}
                    onChange={handleChange}
                  />

                  {errorsTest.file && (
                    <div style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>{errorsTest.file.message}</div>
                  )}
                </>
              )}
            </div>

            {/* SAMPLE DOWNLOAD */}
            <div
              style={{
                border: "2px,solid,lightgray",
                borderRadius: "10px",
                paddingLeft: "50px",
                marginBottom: "10px",
                paddingTop: "15px",
                paddingRight: "25px",
                paddingBottom: "15px",
                marginTop: "10px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                alignItems: "center",
              }}
            >
              <small style={{ color: "crimson" }}>Download sample Excel</small>
              <a href={`${BASE_EXCEL_URL}/upload-package-tests-catalog`} download>
                <button className="btn btn-outline-primary btn-sm">
                  <Icon name="download" className="me-1" />
                  Sample
                </button>
              </a>
              {/* <Button size="sm" color="primary" outline onClick={handleSampleFileOpen}>
                <Icon name="download" /> Sample
              </Button> */}
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default LabBoy;
